<template>
  <!-- Add persistant back after getting this part working -->
  <v-dialog :value="value" @click:outside="$emit('update:value', false)" :width="loading ? '350px' : '1800px'"> 
    <v-card v-if="loading" height="200">
      <v-card-title class="justify-center" width="500px">
        Processing Items
      </v-card-title>
      <div class="py-4 text-center">
        <v-progress-circular class="justify-center" indeterminate size="100" width="5"/>
      </div>

    </v-card>
    <v-card v-else color='#e1e1e1' >
      <v-toolbar flat dark dense class="main">
        <v-toolbar-title>
        Verify DSD Upload
        </v-toolbar-title>
      </v-toolbar>
      <div v-for="table in tables" :key="table.operation">
        <v-card class="justify-center mx-auto my-2"  width="1780px">
          <v-card-title class="py-2">
            {{ `Items to ${table.operation}: ${table.table.length}` }}
          </v-card-title>
          <v-data-table
            :headers="table.headers"
            :items="table.table"
            :item-class="getRowClass"
            :height='tableHeight(table.table)'
            :items-per-page="-1"
            fixed-header
            dense
            hide-default-footer
            disable-sort>

            <template #[`item.sale_price`]="{ item }">
              {{ !isEmpty(item.sale_price)  ? '$' + item.sale_price : '' }}
            </template>

            <template #[`item.cost`]="{ item }">
              {{ !isEmpty(item.cost)  ? '$' + item.cost : '' }}
            </template>

            <template #[`item.future_cost`]="{ item }">
              {{ !isEmpty(item.future_cost)  ? '$' + item.future_cost : '' }}
            </template>
            
          </v-data-table>
        </v-card>
      </div>
      <v-card-actions>
        <v-card-text v-if="!allValid" class="red accent-1 rounded mr-4 elevation-4 py-2" style="font-size:16px">
          One or more items to be added are missing required data fields. Please go back and add the needed fields, or verify the Item ID and UPC if this item should already exist.
        </v-card-text>
        <v-spacer></v-spacer>
        <v-btn
          color="gray"
          dense
          medium
          @click="$emit('update:value', false)">
          Cancel
        </v-btn>
        <v-btn
          color="success"
          dense
          medium
          :disabled="!allValid"
          @click="$emit('submit')">
          Submit
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>

// API
import Items from '@/api/endpoints.js'

export default {
  data () {
    return {
      loading: false,
      cellSize: 44,
      maxTableHeight: 160,
      addItems: [],
      updateItems: [],
      deleteItems: [],
      allValid: false,
      requiredFields: {
        awg: [
          'upc', 'description', 'item_id', 'department', 'vendor_id', 'vendor_name', 
          'pack_size', 'sale_price', 'cost', 'category', 'subcategory', 'qty_per_case'
        ]
      }
    }
  },
  name: 'DSDVerifyModal',
  mixins: [],
  props: {
    value: Boolean,
    headers: Array,
    items: Array,
    selectedSources: Array
  },
  computed: {
    tableHeaders () {
      const source = { align: 'center', text: 'Source', value: 'source' }
      const altered = [ source, ...this.headers ]
      return altered.filter(header => header.value != 'delete_item')
    },
    addHeaders() {
      return this.tableHeaders.flatMap(item => {
        return { ...item, class: 'green lighten-4 black--text text-no-wrap' }
      })
    },
    updateHeaders() {
      return this.tableHeaders.flatMap(item => {
        return { ...item, class: 'blue lighten-4 black--text text-no-wrap' }
      })
    },
    deleteHeaders() {
      return this.tableHeaders.flatMap(item => {
        return { ...item, class: 'red lighten-4 black--text text-no-wrap' }
      })
    },
    visibleTables() {
      return this.tables.length
    },
    tables () {
      let toReturn = []

      if (this.addItems.length > 0) {
        let tableInfo = {
          'table': this.addItems,
          'operation': 'Add',
          'headers': this.addHeaders
        }
        toReturn.push(tableInfo)
      }

      if (this.updateItems.length > 0) {
        let tableInfo = {
          'table': this.updateItems,
          'operation': 'Update',
          'headers': this.updateHeaders
        }
        toReturn.push(tableInfo)
      }

      if (this.deleteItems.length > 0) {
        let tableInfo = {
          'table': this.deleteItems,
          'operation': 'Delete',
          'headers': this.deleteHeaders
        }
        toReturn.push(tableInfo)
      }

      return toReturn
    }
  },
  created() {
    this.loading = true
    this.processItems()
  },
  methods: {
    async processItems() {
      this.allValid = true
      const toDelete = this.items.filter(item => item.delete_item == true)
      this.deleteItems = this.explodeSources(toDelete)

      const nonDelete = this.items.filter(item => item.delete_item == false || item.delete_item == null)

      for (let item of nonDelete) {
        let payload = {
          "sources": this.selectedSources.flatMap(source => source.source_id),
          "item_id": item.item_id,
          "upc": item.upc
        }
        const result = await Items.searchItems(payload, 0, 100, false, true)

        if (result.length == this.selectedSources.length) {
          let toUpdate = this.explodeSources([item])
          this.updateItems = [...this.updateItems, ...toUpdate]
        } else {
          const presentSources = this.selectedSources.filter(source => result.map(item => item.source).includes(source.source_id)).map(source => source.source_name)
          const toFilter = this.explodeSources([item])

          const toUpdate = toFilter.filter(item => presentSources.includes(item.source))
          const toAdd = toFilter.filter(item => !presentSources.includes(item.source))

          this.updateItems = [...this.updateItems, ...toUpdate]
          this.addItems = [...this.addItems, ...toAdd]
        }
      }
      this.allValid = this.verifyItemsToAdd()
      this.loading = false
    },
    verifyItemsToAdd() {
      let noErrors = true

      if (this.addItems.length == 0) {
        return noErrors
      }

      for (const item of this.addItems) {
        const hasEmptyRequiredField = this.requiredFields[this.$auth.tenant].some(field => 
          this.isEmpty(item[field])
        )
        if (hasEmptyRequiredField) {
          item.isValid = false
          noErrors = false
        }
      }

      return noErrors
    },
    getRowClass(item) {
      if (item.isValid == false) {
        return 'red--text'
      }
    },
    tableHeight (items) {
      const size = (items.length + 1) * this.cellSize
      const maxTableHeight = 480 / this.visibleTables
      const min = Math.min(size, maxTableHeight)
      return `${min}px`
    },
    explodeSources(baseArray) {
      let explodedArray = []
      for (const item of baseArray) {
        for (const source of this.selectedSources) {
          explodedArray.push({ source: source.source_name, ...item })
        }
      }
      return explodedArray
    },
    isEmpty (value) {
      return value == null || (typeof value === 'string' && value.trim() === '') || value === ''
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/items/DSDVerifyModal.vue